export const S = () => <svg width="67" height="51" viewBox="0 0 67 51" fill="none">
    <path d="M0 51H4.09375V4.125H62.9062V51H67V0H0V51Z" fill="#DFDFDF"></path>
    <rect x="8" y="8" width="51" height="11" stroke="currentColor" strokeWidth="2"></rect>
    <rect x="10.5" y="10.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="12.5" y="12.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="22.5" y="10.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="24.5" y="12.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="34.5" y="10.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="36.5" y="12.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="46.5" y="10.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="48.5" y="12.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="8" y="23" width="51" height="11" stroke="currentColor" strokeWidth="2"></rect>
    <rect x="10.5" y="25.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="12.5" y="27.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="22.5" y="25.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="24.5" y="27.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="34.5" y="25.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="36.5" y="27.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="46.5" y="25.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="48.5" y="27.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="8" y="38" width="51" height="11" stroke="currentColor" strokeWidth="2"></rect>
    <rect x="10.5" y="40.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="12.5" y="42.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="22.5" y="40.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="24.5" y="42.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="34.5" y="40.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="36.5" y="42.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="46.5" y="40.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="48.5" y="42.5" width="6" height="2" stroke="currentColor"></rect>
</svg>

export const M = () => <svg width="68" height="51" viewBox="0 0 68 51" fill="none">
    <rect x="8" y="8" width="52" height="11" stroke="currentColor" strokeWidth="2"></rect>
    <rect x="8" y="23" width="52" height="11" stroke="currentColor" strokeWidth="2"></rect>
    <rect x="8" y="38" width="52" height="11" stroke="currentColor" strokeWidth="2"></rect>
    <path d="M0 51H4.1875V4.1875H63.8125V51H68V0H0V51Z" fill="#DFDFDF"></path>
</svg>

export const L = () => <svg width="68" height="51" viewBox="0 0 68 51" fill="none">
    <rect x="8" y="8" width="52" height="5" stroke="currentColor" strokeWidth="2"></rect>
    <rect x="8" y="17" width="52" height="5" stroke="currentColor" strokeWidth="2"></rect>
    <rect x="8" y="26" width="52" height="5" stroke="currentColor" strokeWidth="2"></rect>
    <rect x="8" y="35" width="52" height="5" stroke="currentColor" strokeWidth="2"></rect>
    <rect x="8" y="44" width="52" height="5" stroke="currentColor" strokeWidth="2"></rect>
    <path d="M0 51H4.1875V4.1875H63.8125V51H68V0H0V51Z" fill="#DFDFDF"></path>
</svg>

export const Filenka = () => <svg width="67" height="51" viewBox="0 0 67 51" fill="none">
    <path d="M0 51H4.09375V4.125H62.9062V51H67V0H0V51Z" fill="#DFDFDF"></path>
    <rect x="8" y="8" width="51" height="11" stroke="currentColor" strokeWidth="2"></rect>
    <rect x="10.5" y="10.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="12.5" y="12.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="22.5" y="10.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="24.5" y="12.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="34.5" y="10.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="36.5" y="12.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="46.5" y="10.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="48.5" y="12.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="8" y="23" width="51" height="11" stroke="currentColor" strokeWidth="2"></rect>
    <rect x="10.5" y="25.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="12.5" y="27.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="22.5" y="25.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="24.5" y="27.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="34.5" y="25.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="36.5" y="27.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="46.5" y="25.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="48.5" y="27.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="8" y="38" width="51" height="11" stroke="currentColor" strokeWidth="2"></rect>
    <rect x="10.5" y="40.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="12.5" y="42.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="22.5" y="40.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="24.5" y="42.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="34.5" y="40.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="36.5" y="42.5" width="6" height="2" stroke="currentColor"></rect>
    <rect x="46.5" y="40.5" width="10" height="6" stroke="currentColor"></rect>
    <rect x="48.5" y="42.5" width="6" height="2" stroke="currentColor"></rect>
</svg>

export const Micro = () => <svg width="68" height="51" viewBox="0 0 68 51" fill="none">
    <path d="M0 51H4.09375V4.125H63.9062V51H68V0H0V51Z" fill="#DFDFDF"></path>
    <rect x="8" y="8" width="52" height="11" stroke="currentColor" strokeWidth="2"></rect>
    <path d="M8 10.5C8 10.5 39.6927 10.5 60 10.5" stroke="currentColor"></path>
    <path d="M8 12.5C8 12.5 39.6927 12.5 60 12.5" stroke="currentColor"></path>
    <path d="M8 14.5C8 14.5 39.6927 14.5 60 14.5" stroke="currentColor"></path>
    <path d="M8 16.5C8 16.5 39.6927 16.5 60 16.5" stroke="currentColor"></path>
    <rect x="8" y="23" width="52" height="11" stroke="currentColor" strokeWidth="2"></rect>
    <path d="M8 25.5C8 25.5 39.6927 25.5 60 25.5" stroke="currentColor"></path>
    <path d="M8 27.5C8 27.5 39.6927 27.5 60 27.5" stroke="currentColor"></path>
    <path d="M8 29.5C8 29.5 39.6927 29.5 60 29.5" stroke="currentColor"></path>
    <path d="M8 31.5C8 31.5 39.6927 31.5 60 31.5" stroke="currentColor"></path>
    <rect x="8" y="38" width="52" height="11" stroke="currentColor" strokeWidth="2"></rect>
    <path d="M8 40.5C8 40.5 39.6927 40.5 60 40.5" stroke="currentColor"></path>
    <path d="M8 42.5C8 42.5 39.6927 42.5 60 42.5" stroke="currentColor"></path>
    <path d="M8 44.5C8 44.5 39.6927 44.5 60 44.5" stroke="currentColor"></path>
    <path d="M8 46.5C8 46.5 39.6927 46.5 60 46.5" stroke="currentColor"></path>
</svg>

